module.exports = __webpack_public_path__ + "static/media/ridelightpro-2.2d5e7701.jpg";